import React from 'react';
import { Box, Typography } from '@mui/material';

export const SectionLabel: React.FC<{ children: React.ReactNode }> = ({ children }) => (
  <Typography variant="overline" color="text.secondary" sx={{ display: 'block', mb: 1 }}>
    {children}
  </Typography>
);

export const DetailField: React.FC<{ label: string; children: React.ReactNode }> = ({ label, children }) => (
  <Box>
    <Typography variant="caption" color="text.secondary" display="block">
      {label}
    </Typography>
    {children}
  </Box>
);

const formatAddressLine = (...parts: (string | null | undefined)[]): string | null => {
  const joined = parts.filter(Boolean).join(', ');
  return joined || null;
};

export const formatStreetLine = (line1: string | null, line2: string | null, line3: string | null): string | null =>
  formatAddressLine(line1, line2, line3);

export const formatCityStateZip = (city: string | null, state: string | null, zip: string | null): string | null => {
  const cityState = [city, state].filter(Boolean).join(', ');
  return [cityState, zip].filter(Boolean).join(' ') || null;
};

export const hasAnyValue = (...parts: (string | null | undefined)[]): boolean => parts.some(Boolean);

export const AddressValue: React.FC<{ street: string | null; cityLine: string | null; extraLine?: string | null }> = ({
  street,
  cityLine,
  extraLine,
}) => (
  <>
    {street && (
      <Typography variant="body2" color="text.primary">
        {street}
      </Typography>
    )}
    {cityLine && (
      <Typography variant="body2" color="text.primary">
        {cityLine}
      </Typography>
    )}
    {extraLine && (
      <Typography variant="body2" color="text.primary">
        {extraLine}
      </Typography>
    )}
    {!street && !cityLine && !extraLine && (
      <Typography variant="body2" color="text.primary">
        —
      </Typography>
    )}
  </>
);
